import { __prod__ } from "src/constants"

let client = null

// Apollo client creation requires browser environment (window)
if (typeof window !== "undefined") {
    const fetch = require("node-fetch")
    const ApolloClient = require("apollo-boost").default

    const production = new ApolloClient({
        uri:
            process.env.GATSBY_GRAPHQL_ENDPOINT_PROD ||
            "https://6zyv223myfblpbkzrv2xqtbkk4.appsync-api.eu-central-1.amazonaws.com/graphql",
        headers: {
            "x-api-key":
                process.env.GATSBY_GRAPHQL_API_KEY_PROD ||
                "da2-tlswfg7gfvejhp2h55frheh77q",
        },
        fetch,
    })

    const dev = new ApolloClient({
        uri:
            process.env.GATSBY_GRAPHQL_ENDPOINT_DEV ||
            "https://373ni2jvzvas5fn6bg3rpfyuge.appsync-api.eu-central-1.amazonaws.com/graphql",
        headers: {
            "x-api-key":
                process.env.GATSBY_GRAPHQL_API_KEY_DEV ||
                "da2-6jsbwwdhhzdnblonssd4usvp74",
        },
        fetch,
    })

    client = __prod__ ? production : dev
}

export default client
